// Business success must come from the API envelope, never HTTP 200 alone.
export function responseCode (body) {
  const value = body && body.code
  return typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value)) ? Number(value) : null
}
export function responseMessage (body, fallback) {
  const value = body && (body.msg || body.message)
  return typeof value === 'string' && value.trim() ? value.trim() : fallback
}
